
  let resizeEvent = ["resize", "orientationchange"];

  // detect if mobile browser. regex -> http://detectmobilebrowsers.com
  var isMobile = (function(a){return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))})(navigator.userAgent||navigator.vendor||window.opera);

  var windowH = 0;
  var windowW = 0;
  var videoOpt = {taped: false};

  function getReadingTime(fullText){
    wordCount = fullText.replace( /[^\w ]/g, "" ).split( /\s+/ ).length;

    var readingTimeInMinutes = Math.floor(wordCount / 228) + 1;
    return readingTimeInMinutes;
  }

  function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  };

  function IsJsonString(str) {
    try{
      JSON.parse(str);
    }
  	catch(e){
      return false;
    }
    return true;
  }

  if (typeof JSON.clone !== "function") {
    JSON.clone = function(obj) {
      return JSON.parse(JSON.stringify(obj));
    };
  }

  String.prototype.trunc = function(n,useWordBoundary){
  	var toLong = this.length>n, s_ = toLong ? this.substr(0,n-1) : this;
  	s_ = useWordBoundary && toLong ? s_.substr(0,s_.lastIndexOf(' ')) : s_;
  	return  toLong ? s_ + '&hellip;' : s_;
  };

  String.prototype.reverse = function(){
  	return  this.split("").reverse().join("");
  };

  String.prototype.replaceAll = function(search, replacement) {
    let target = this;
    if(Array.isArray(search) && Array.isArray(replacement) && replacement.length == search.length){
      search.forEach((serchItem, i) => {
        target = target.replace(new RegExp(serchItem, 'g'), replacement[i]);
      });

    }
    else{
      target = target.replace(new RegExp(search, 'g'), replacement);
    }

    return target;
  };

  Number.prototype.pad = function(size){
    let s = String(this);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
  }

  if((typeof Element.prototype.remove) == 'undefined'){
    Element.prototype.remove = function() {
      this.parentElement.removeChild(this);
    }
  }

  if((typeof NodeList.prototype.remove) == 'undefined'){
    NodeList.prototype.remove = HTMLCollection.prototype.remove = function() {
      for(var i = this.length - 1; i >= 0; i--) {
        if(this[i] && this[i].parentElement) {
          this[i].parentElement.removeChild(this[i]);
        }
      }
    }
  }

  if (typeof Array.prototype.inArray !== "function") {
    Array.prototype.inArray = function(needle) {
      let haystack = this;
      let found = false;
      if(haystack.length == 0){
        found = false;
      }
      else{
        haystack.forEach((item, i) => {
          if(item == needle){
            found = true;
            return false;
          }
        });
      }
      return found;
    };
  }

  if (typeof Array.prototype.remove !== "function") {
    Array.prototype.remove = function() {
      var what, a = arguments, L = a.length, ax;
      while (L && this.length) {
          what = a[--L];
          while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
          }
      }
      return this;
    };
  }


  function isNumeric(n) {
  	return !isNaN(parseFloat(n)) && isFinite(n);
  }

  function isInt(n){
    return Number(n) === n && n % 1 === 0;
  }

  function isFloat(n){
    return Number(n) === n && n % 1 !== 0;
  }

  function collectionHas(a, b) { //helper function (see below)
    for(var i = 0, len = a.length; i < len; i ++) {
        if(a[i] == b) return true;
    }
    return false;
  }

  function findParentBySelector(elm, selector) {
    var all = document.querySelectorAll(selector);
    var cur = elm.parentNode;
    while(cur && !collectionHas(all, cur)) { //keep going up until you find a match
        cur = cur.parentNode; //go up
    }
    return cur; //will return null if not found
  }

  function getJSONsize(data){
  	var key, count = 0;
  	for(key in data) {
  	  if(data.hasOwnProperty(key)) {
  	    count++;
  	  }
  	}
  	return count;
  }

  function pathPrepare ($el) {
    var lineLength = $el[0].getTotalLength();
    $el.css("stroke-dasharray", lineLength);
    $el.css("stroke-dashoffset", lineLength);
  }

  function goTo(element, offset, timing, callback, callbackData){
    var timing = timing || 1000;
    var offset = offset || 0;
    offset = parseInt(offset);
    var callback = callback || function(){};
    var callbackData = callbackData || "";
  	(function ($) {
  		var value = jQuery(element).offset().top - offset;
  	  $('html, body').stop().animate({
  			'scrollTop': value
  		}, timing, 'swing');
      setInterval(timing, callback(callbackData));
  	})(jQuery);
  }

  function goToBinder(){
    $(".goTo").click(function(){
      var target = $(this).data("goto-target");
      var offset = 0;
      var timing = 700;

      if($(this).data("offset") != undefined){
        offset = $(this).data("offset");
      }
      else{
        offset = $("#menuBlock").height();
      }

      if($(this).data("timing") != undefined){
        timing = $(this).data("timing");
      }

      goTo(target, offset, timing);
    });
  }

  function setVerticalAlign(functionalLimit){
    functionalLimit = functionalLimit || 767;
    $(".col-vertical-align").each(function(){
      if($(window).width() > functionalLimit){
        if($(this).data("vertical-rel-to") != undefined){
          var selector = $(this).data("vertical-rel-to");
          var h = $(this).parents(selector).height();
        }
        else{
          var h = $(this).parents(".row").height();
        }
        $(this).css('margin-top', ((h - parseInt($(this).css('height'))) / 2) + 'px');
      }
      else{
        $(this).css('margin-top', '');
      }
    });
  }

  function setHeightFrom(){
    $("[data-set-height-from]").each(function(){
      var from = $(this).data("set-height-from");
      var h = $(from).outerHeight(true);
      $(this).css("height", h);
    })
  }

  function setHeightToMaxOfSiblings(){
    var maxH = 0;
    $("[data-find-max-height]").each(function(){
      $(this).css("height", "auto");
      if($(this).outerHeight(true) > 0){
        maxH = $(this).outerHeight(true);
      }
    });

    $("[data-find-max-height]").each(function(){
      $(this).height(maxH);
    });
  }

  function setPositionFromParent(){
    $("[data-set-position-from-parent]").each(function(){
      var elem = $(this);
      var position = elem.data("set-position-from-parent");
      var h = parseInt(elem.css("height"));
      var ph = parseInt(elem.parent().css("height"));
      switch(position){
        case 'center':
          elem.css("margin-top", ((ph - h)/2) + "px");
          break;
        case 'bottom':
          elem.css("margin-top", ((ph - h)/2) + "px");
      }
    });
  }

  function findMinMax(el, minMax){
    minMax = minMax || {min: null, max: null};

    if(minMax.min == null){
      minMax.min = el;
    }

    if(minMax.max == null){
      minMax.max = el;
    }

    if(el < minMax.min){
      minMax.min = el;
    }

    if(el > minMax.max){
      minMax.max = el;
    }

    return minMax;
  }

  function initMap(){
    var locations = [{coordinates: {lat: 40.978188, lng: 17.116921}}];
    if(document.getElementById("map-canvas") != null){

      var marker, centerMap;
      var zoom = 17;

      function move(){
        map.setCenter(centerMap);
        marker.setPosition(centerMap);
      }

      function initialize() {

        var minMaxLat = {min: null, max: null};
        var minMaxLng = {min: null, max: null};

        for(var i = 0; i < locations.length; i++){
          var loc = locations[i];
          minMaxLat = findMinMax(parseFloat(loc.coordinates.lat), minMaxLat);
          minMaxLng = findMinMax(parseFloat(loc.coordinates.lng), minMaxLng);
        }

        var lat = (minMaxLat.min + minMaxLat.max) / 2;
        var lng = (minMaxLng.min + minMaxLng.max) / 2;

        centerMap = new google.maps.LatLng(lat, lng);

        var mapOptions = {
          zoom: zoom,
          center: centerMap,
          scrollwheel: false
        };

        map = new google.maps.Map(document.getElementById("map-canvas"), mapOptions);

        var i;
        //var image = "../images/indicatore.png"; ?>";

        for (i = 0; i < locations.length; i++) {
          marker = new google.maps.Marker({
            position: new google.maps.LatLng(locations[i].coordinates.lat, locations[i].coordinates.lng),
            map: map,
            animation: google.maps.Animation.DROP,
            //icon: image
          });
        }

        google.maps.event.addDomListener(window, "resize", move);

      }

      google.maps.event.addDomListener(window, "load", initialize);
    }

    if(document.getElementById("street-view") != null){
      panorama = new google.maps.StreetViewPanorama(
        document.getElementById('street-view'),
        {
          position: {lat: locations[0].coordinates.lat, lng: locations[0].coordinates.lng},
          pov: {heading: 0, pitch: 0},
          zoom: 1,
          motionTracking: false,
          motionTrackingControlOptions: {
            position: google.maps.ControlPosition.LEFT_BOTTOM
          }
        }
      );
    }

  }

  function moveMap(map, location, zoom){
    zoom = zoom || 10;
    let lat = location.lat;
    let long = location.lng;

    latlngset = new google.maps.LatLng(lat, long);

    if(map.map != undefined && map.map != null){
      map.map.setCenter(latlngset);
      map.map.setZoom(zoom);
    }

    if(map.marker != undefined && map.marker != null){
      map.marker.setPosition(latlngset);
    }
  }

  function setFullScreenSize(){
    windowW = $(window).width();
    windowH = $(window).height();
    var menuH = $("#menuBlock").height();
    var visibleH = windowH - menuH;
    $(".fullScreen").each(function(){
      $(this).width(windowW);
      $(this).height(visibleH);
    });
  }

  function setVideoDim(selector, opts){

    let defaults = {
      taped: false,
      containerW: parseInt($(window).width()),
      containerH: parseInt($(window).height()),
      callback: function(){},
      videoNativeRatio: 16/9,
      callbackData: null,
      ancorX: "center",
      ancorY: "center",
    }

    let options = $.extend(true, {}, defaults, opts);
    let containerId = selector;
    let videoResizeTimeout;

    function heightTied(){
      w = parseInt(options.containerH * options.videoNativeRatio);
      return {
        width: w,
        height: options.containerH
      }
    }

    function widthTied(){
      h = parseInt(options.containerW / options.videoNativeRatio);
      return {
        width: options.containerW,
        height: h
      }
    }

    function setSize(){
      if($(selector) != undefined){
        let containerRatio = options.containerW / options.containerH;
        let dim;

        if(options.videoNativeRatio == containerRatio){
          dim.height = options.containerH;
          dim.widht = options.containerW;
        }
        else{

          if((options.videoNativeRatio > 1 && containerRatio > 1) || (options.videoNativeRatio < 1 && containerRatio < 1)){ // caso video orizzontale e finestra orizzontale
            if(options.videoNativeRatio < containerRatio){ // video meno largo della finestra
              if(options.taped){
                dim = heightTied();
              }
              else{
                dim = widthTied();
              }
            }
            else{ // video più largo della finestra
              if(options.taped){
                dim = widthTied();
              }
              else{
                dim = heightTied();
              }
            }
          }
          else if(options.videoNativeRatio > 1 && containerRatio < 1){ // caso video orizzontale e finestra verticale
            if(options.taped){
              dim = widthTied();
            }
            else{
              dim = heightTied();
            }
          }
          else{ // caso video verticale e finestra orizzontale
            if(options.taped){
              dim = heightTied();
            }
            else{
              dim = widthTied();
            }
          }
        }

        $(selector + " > video").attr("height", dim.height);
        $(selector + " > video").attr("width", dim.width);

        let translateCss = "translate(";
        if(options.ancorX == "left"){
          $(selector + " > video").css("left", "0px");
          translateCss += "0";
        }
        if(options.ancorX == "right"){
          $(selector + " > video").css("right", "0px");
          translateCss += "100%";
        }
        if(options.ancorX == "center"){
          $(selector + " > video").css("left", "50%");
          translateCss += "-50%";
        }

        if(options.ancorY == "top"){
          $(selector + " > video").css("top", "0px");
          translateCss += ", 0%)";
        }
        if(options.ancorY == "bottom"){
          $(selector + " > video").css("bottom", "0px");
          translateCss += ", 100%)";
        }
        if(options.ancorY == "center"){
          $(selector + " > video").css("top", "50%");
          translateCss += ", -50%)";
        }

        $(selector + " > video").css("transform", translateCss);
        $(selector + " > video").css("position", "relative");

        options.callback(options.callbackData);
      }
      else{
        console.log("no video: inert activation");
      }
    }

    setSize();

    window.addEventListener('resize', function(){
      clearTimeout(videoResizeTimeout);
      videoResizeTimeout = setTimeout(function(){
        options.containerW = $(containerId).width();
        options.containerH = $(containerId).height();
        setSize();
      }, 100);
    });

  }

  $(document).ready(function(){

    $(".smoothScroll").click(function(e){
      if($(this).data("prevent-default-link") == 1){
        e.preventDefault();
      }
    });

    window.addEventListener('resize', baseResizeHandler);

  });

  function baseResizeHandler(){
    setVerticalAlign(991);
    //menuMinifierController();
    setFullScreenSize();
    setHeightFrom();
    setHeightToMaxOfSiblings();
    isMobile = (function(a){return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))})(navigator.userAgent||navigator.vendor||window.opera);
  }

  $(window).bind("load", function(){
    goToBinder();
    setHeightFrom();
    setHeightToMaxOfSiblings();
  });
